import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import {
  PageHeader,
  InfoBox,
  PageMetadata,
  ViewBlocks,
  RelatedItems,
} from '@redturtle/iovisit-theme/components/Views';

import { When } from '@redturtle/iovisit-theme/components';

const messages = defineMessages({
  newsDate: {
    id: 'news_date',
    defaultMessage: 'Data',
  },
  related_items: {
    id: 'news_related_items',
    defaultMessage: 'Scopri le altre notizie',
  },
});

const NewsItemView = ({ content, location }) => {
  const intl = useIntl();

  return (
    <div id="page-news" className="ui container">
      {content.effective && (
        <InfoBox>
          <h3>{intl.formatMessage(messages.newsDate)}</h3>
          <When
            start={content.effective}
            end={content.effective}
            show_times={false}
          />
        </InfoBox>
      )}

      <ViewBlocks content={content} location={location} />

      {content.relatedItems?.length > 0 && (
        <RelatedItems
          title={intl.formatMessage(messages.related_items)}
          items={content.relatedItems}
          background={true}
        />
      )}
    </div>
  );
};

export default NewsItemView;
